import { isEmpty, isUndefined } from 'lodash';

export const normalizeURLPath = (path: string) => {
  let result = path;
  while (result.startsWith('/')) result = result.slice(1);
  while (result.endsWith('/')) result = result.slice(0, -1);
  return result;
};

export const buildUrl = (baseUrl: string, params: Record<string, string | undefined>) => {
  const url = new URL(baseUrl);
  Object.entries(params).forEach(([key, value]) => {
    if (!isUndefined(value) && !isEmpty(value)) {
      url.searchParams.append(key, value);
    }
  });
  return url.toString();
};
